import request from '@/utils/request'

export function login(data) {
	return request({
		url: '/user/user/login',
		method: 'get',
		params: data
	})
}

//短信验证
export function phonecode(phone) {
  return request({
    url: '/user/user/getphonecode',
    method: 'get',
    params: { phone }
  })
}

export function getinfo() {
	return request({
		url: '/user/user/getinfo',
		method: 'get',
	})
}
